import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ey-summary-row',
  templateUrl: './summary-row.component.html',
  styleUrls: ['./summary-row.component.scss'],
})
export class SummaryRowComponent implements OnInit {
  @Input() label: string = null;

  constructor() {}

  ngOnInit(): void {}

  get hasLabel(): boolean {
    return !!this.label;
  }
}
